import { SVGProps } from 'react';

export const Contact = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 8C10.206 8 12 6.206 12 4C12 1.794 10.206 0 8 0C5.794 0 4 1.794 4 4C4 6.206 5.794 8 8 8"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 9C3.29 9 0 11.467 0 15V16H16V15C16 11.467 12.71 9 8 9"
      fill="currentColor"
    />
  </svg>
);
